import React from 'react';
import { Col, Row, Label, Button, Input, FormGroup, Spinner } from 'reactstrap';
import { AvForm, AvField } from 'availity-reactstrap-validation';
import AsyncSelect from 'react-select/async';
import Select from 'react-select';
import debounce from 'lodash.debounce';
import preventValueChangeOnScroll from '../../../helpers/PreventValueOnScroll';
import AddCustomerModal from '../../../components/Common/AddCustomerModal';

const CheckoutForm = (props) => {
  const { 
    t, refContainer, CheckAmounts, remainingPaidAmount, 
    totalPrice, discountTracker, postdiscountAmount, applyDiscount, 
    discountInput, handleSplitBill, isBillsplit, 
    billSplitBetween, handleBillSplitBetweenChange, billSplitAmount, splitCustomers, 
    customers, paymentMethods, isNoChange, remarks, 
    finalChange, handleChangeAmount, totalPaidByAllSplitCustomers, is_personDisappear, handleValidSubmit, 
    handleValidSubmitUnpaid, vipsDiscount, selectedPaymentMethods, customerDetails, 
    handlePaymentMethodChange, formFieldValues, totalPaidAmount, setState, handlePaymentAmountChange,
    fetchCustomers,handleAddCustomer,toggle,addCustomerModal, handleEnableWallet,handleEnableWalletForCustomer,isVipDiscountApplied ,
    originalTotalPrice,isSubmitting
  } = props;
  
// console.log(splitCustomers,"spli");

  const loadOptions = (inputValue, callback) => {
    if (inputValue.length < 3) {
      callback([]);
      return;
    }
    debouncedLoadOptions(inputValue, callback, splitCustomers);
  };
  
  
  const debouncedLoadOptions = debounce((inputValue, callback, splitCustomers) => {
    fetchCustomers(inputValue).then((data) => {
      const selectedCustomerIds = splitCustomers.map(split => split.customer?._id).filter(Boolean);
      const filteredData = data?.filter(customer => !selectedCustomerIds.includes(customer._id));
      const options = filteredData?.map(c => ({ value: c._id, label: `${c.name} [${c.mobile})] [${c.customer_type})]` }));
      
      callback(options);
    });
  }, 500);
  

  return (
    <AvForm onValidSubmit={CheckAmounts} ref={refContainer}>
      <Row>
        <Col lg={6} style={{ marginBottom: "1.5rem" }}>
          <div style={{ maxWidth: "99%", paddingTop: "5px", display: "flex", justifyContent: "center", alignItems: "center", gap: "5px", boxShadow: "rgba(3, 102, 214, 0.3) 0px 0px 0px 3px" }}>
            <h6 style={{ color: "#0b1f32", fontWeight: "bold" }}>Remaining Amount To Pay:</h6>
            <h6 style={{ color: remainingPaidAmount <= 0 ? "#36B94D" : "#FA395D", fontWeight: "bold", fontSize: "17px" }}>
              {`QR ${remainingPaidAmount == 0 ? "0.00" : remainingPaidAmount < 0 ? "+" + Math.abs(remainingPaidAmount).toFixed(2) : "-" + Math.abs(remainingPaidAmount).toFixed(2)}`}
            </h6>
          </div>
        </Col>
        <Col lg={6}>
          <div style={{ maxWidth: "99%", paddingTop: "5px", display: "flex", justifyContent: "center", alignItems: "center", gap: "5px", boxShadow: "rgba(3, 102, 214, 0.3) 0px 0px 0px 3px" }}>
            <h6 style={{ color: "#0b1f32", fontWeight: "bold" }}>Amount To Pay:</h6>
            <h6 style={{ color: "#FA395D", fontWeight: "bold", fontSize: "17px" }}>
              {`QR ${+totalPrice?.toFixed(2)}`}
            </h6>
          </div>
        </Col>
      </Row>

      <Row>
        <Col lg={5}>
          <span style={{ fontSize: "10px", visibility: `${discountTracker && postdiscountAmount > 0 ? "unset" : "hidden"}`}} className="text-muted">
            {t("Amount Reduced By")}:{"  "}
            <span style={{ color: "red", fontWeight: "600" }}>{postdiscountAmount}</span>
          </span>
          <div style={{ height: "30px", display: "flex", justifyContent: "flex-start", alignItems: "center", gap: "18px" }}>
            <Label>Discount Coupon</Label>
            <Button style={{ width: "100px", height: "25px", marginTop: "-10px", boxShadow: "none", transition: "transform 0.3s ease" }} onMouseEnter={e => { e.target.style.transform = "scale(1.05)" }} onMouseLeave={e => { e.target.style.transform = "scale(1)" }} className="btn btn-info btn-sm " onClick={applyDiscount} disabled={discountTracker}>
              Apply Coupon
            </Button>
          </div>
          <AvField id="discountInput"
           name="discount" 
           disabled={!isBillsplit && isVipDiscountApplied}
           type="text" placeholder={t("Enter Coupon Code ")} value={discountInput} onChange={e => setState({ discountInput: e.target.value })} />
        </Col>
        <Col size={3}>
          <div className="mt-5">
            <Button type="button" onClick={handleSplitBill} style={{ position: "relative", overflow: "hidden", backgroundColor: "#fdd005", border: "none", color: "black", fontSize: "14px", fontWeight: "500", width: "128px", marginLeft: "12px", boxShadow: "rgba(255, 255, 255, .2) 0 3px 15px inset, rgba(0, 0, 0, .4) 0 3px 5px, rgba(0, 0, 0, .1) 0 10px 13px", transition: "transform 0.3s ease" }} onMouseEnter={e => { e.target.style.transform = "scale(1.05)" }} onMouseLeave={e => { e.target.style.transform = "scale(1)" }}>
              <i className="fa fa-users"> </i>
              &nbsp; {isBillsplit ? "Cancel" : "Split Bill"}
              <div style={{ position: "absolute", top: "0", left: "0", right: "0", bottom: "0", background: "linear-gradient(rgba(255, 255, 255, 0.5), rgba(255, 255, 255, 0))", pointerEvents: "none" }}></div>
            </Button>
          </div>
        </Col>

        {/* Add Customer  */}
        <Col size={3} hidden={!isBillsplit}>
          <div className="mt-5">
            <Button type="button" onClick={() => setState({ addCustomerModal: true })} style={{ position: "relative", overflow: "hidden", backgroundColor: "#fdd005", border: "none", color: "black", fontSize: "14px", fontWeight: "500", marginLeft: "5px", boxShadow: "rgba(255, 255, 255, .2) 0 3px 15px inset, rgba(0, 0, 0, .4) 0 3px 5px, rgba(0, 0, 0, .1) 0 10px 13px", transition: "transform 0.3s ease" }} onMouseEnter={e => { e.target.style.transform = "scale(1.05)" }} onMouseLeave={e => { e.target.style.transform = "scale(1)" }}>
              <i className="fa fa-user-plus"> </i>
              &nbsp; {"Add Customer"}
              <div style={{ position: "absolute", top: "0", left: "0", right: "0", bottom: "0", background: "linear-gradient(rgba(255, 255, 255, 0.5), rgba(255, 255, 255, 0))", pointerEvents: "none" }}></div>
            </Button>
          </div>
        </Col>
        <Col lg={4} hidden={isBillsplit}>
          <FormGroup check className="mt-5 mb-2" style={{ display: customerDetails[0]?.customer_type === "VIP" ? "none" : "flex", justifyContent: "center" }}>
            <Label check className="ms-5">
              <Input style={{ border: "0.5px solid black" }} type="checkbox" checked={isNoChange} onChange={e => setState({ isNoChange: e.target.checked })} />
              {t("No Change")}
            </Label>
          </FormGroup>
        </Col>
      </Row>

      {isBillsplit && (
        <>
          <Row>
            <Col lg={6}>
              <Label>Split Between</Label>
              <AvField id="billSplitBetween" name="billSplitBetween" type="number" placeholder="Enter number of people" value={billSplitBetween} onChange={handleBillSplitBetweenChange} onWheel={preventValueChangeOnScroll} min="2" validate={{ required: { value: true, errorMessage: "This field is required for bill split" }, min: { value: 2, errorMessage: "Minimum 2 people for bill split" } }} />
            </Col>
            <Col lg={6}>
              <Label>Total Split Amount (per person)</Label>
              <AvField id="billSplitAmount" name="billSplitAmount" type="number" value={billSplitAmount || "0"} readOnly disabled />
            </Col>
          </Row>

          {splitCustomers.map((split, index) => {
            const customer = split.customer;
            const isVIP = customer?.customer_type === "VIP";

            return (
              <Row key={split.id} className="split-card">
                <Col lg={6} xs={12} className="mb-2">
                  <Label className="split-label">
                    Customer {index + 1}{" "}
                    {customer?.customer_type && (
                      <span className={`split-badge ${isVIP ? "bg-danger text-white" : "bg-primary text-white"}`}>
                        {customer.customer_type}
                      </span>
                    )}
                  </Label>
                  <AsyncSelect
                    loadOptions={loadOptions}
                    defaultOptions
                    value={customer ? { value: customer._id, label: customer.name } : null}
                    onChange={selected => {
                      const updated = [...splitCustomers];
                      const newCustomer = customers.find(c => c._id === selected.value);
                      updated[index] = {
                        ...updated[index],
                        customer: newCustomer,
                        paymentMethods: [],
                        paymentDetails: {},
                        paidAmount: newCustomer?.customer_type === "VIP" ? 0 : billSplitAmount, // Keep original paidAmount or set to 0 for VIP
                        changeAmount: 0,
                        isNoChange: false,
                      };
                      setState({ splitCustomers: updated });
                    }}
                  />
                </Col>

                <Col lg={6} xs={12} className="mb-2">
                  <Label className="split-label">Payment Method</Label>
                  <Select
                    isMulti
                    isDisabled={isVIP || !customer}
                    options={paymentMethods?.map(method => ({
                      value: method._id,
                      label: method.name,
                      image_url: method.image_url,
                      isDisabled: method.name === "Wallet" && !split?.customer?.is_wallet_eligible
                    }))}
                    value={split?.paymentMethods}
                    onChange={methods => {
                      const updated = [...splitCustomers];
                      updated[index].paymentMethods = methods;
                      setState({ splitCustomers: updated });
                    }}
                  />

                  {customer && !customer.is_wallet_eligible && !isVIP && (
                    <label style={{ cursor: "pointer" , display:"flex"}} className="toggle-wallet">
                      <input
                        type="checkbox"
                        name="wallet"
                        onChange={() => {
                          handleEnableWallet(customer?._id, index);
                        }}
                      />
                      <span className="ms-1">Enable Wallet</span>
                    </label>

                  )}

                  {split?.paymentMethods?.some(pm => pm.label === "Wallet") && (
                    <div className="split-wallet text-muted">
                      Balance:{" "}
                      <span style={{ color: "red", fontWeight: "600" }}>
                        {customer?.wallet || 0}
                      </span>
                    </div>
                  )}
                </Col>

                <Row>
                  {split?.paymentMethods?.map((pm, pmIndex) => {

                    const totalPaidExcludingCurrent = split.paymentMethods.reduce((acc, currentPm, i) => {
                      if (i === pmIndex) { 
                        return acc;
                      }
                      return acc + (currentPm.amount || 0);
                    }, 0);
                  
                    const customValidation = (value) => {
                      const currentAmount = Number(value || 0);
                      const totalPaidIncludingCurrent = totalPaidExcludingCurrent + currentAmount;
                  
                      if (!split.isNoChange && totalPaidIncludingCurrent < split.paidAmount) {
                        return "Amount required to cover split total";
                      }
                      return true;
                    };

                    return (
                    <Col key={pm.value} lg={4} md={4} xs={12}>
                      <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                        <img src={pm.image_url} alt={pm.label} style={{ width: "21px", height: "21px", objectFit: "contain" }} />
                        <span style={{ fontSize: "13px", lineHeight: "1.2" }}>
                          By {pm.label}
                        </span>
                      </div>
                      <AvField type="number" min="0" name={`splitAmount_${split.id}_${pm.value}`} placeholder="Amount"        
                      value={pm.amount || ""} 
                      onWheel={preventValueChangeOnScroll}
                      onChange={e => {
                        const updated = [...splitCustomers];
                        const currentSplit = updated[index];
                        currentSplit.paymentMethods[pmIndex].amount = Number(e.target.value);
                        // if (!currentSplit.isNoChange) {
                          const totalPaidByCustomer = currentSplit.paymentMethods.reduce((acc, m) => acc + (m.amount || 0), 0);
                          currentSplit.changeAmount = totalPaidByCustomer - currentSplit.paidAmount;
                        // }
                        setState({ splitCustomers: updated });
                      }} 
                      validate={{ custom: customValidation }}
                      style={{ maxWidth: "200px", marginTop: "0px", boxShadow: "rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.06) 0px 2px 4px -1px" }} />
                    </Col>
                  )})}

                  <Row>
                    <Col lg={3} xs={12} className="mt-3">
                      <div className="split-label2">Total Paid:
                        <span style={{ fontWeight: "bold", marginLeft: "5px", color: "#36B94D" }}>
                          QR {split?.paymentMethods?.reduce((acc, m) => acc + (m.amount || 0), 0)?.toFixed(2)}
                        </span>
                      </div>
                    </Col>
                    <Col lg={3} xs={12} className="mt-3">
                      <div className="split-label2">Remaining:
                        <span style={{ fontWeight: "bold", marginLeft: "5px", color: (split?.paidAmount - split?.paymentMethods?.reduce((acc, m) => acc + (m.amount || 0), 0)) <= 0 ? "#36B94D" : "#FA395D" }}>
                          QR {isVIP ? "0.00" : ((split?.paidAmount - split?.paymentMethods?.reduce((acc, m) => acc + (m.amount || 0), 0)) === 0 ? "0.00" : (split?.paidAmount - split?.paymentMethods?.reduce((acc, m) => acc + (m.amount || 0), 0)) < 0 ? "+" + Math.abs((split?.paidAmount - split?.paymentMethods?.reduce((acc, m) => acc + (m.amount || 0), 0)))?.toFixed(2) : "-" + Math.abs((split?.paidAmount - split?.paymentMethods?.reduce((acc, m) => acc + (m.amount || 0), 0)))?.toFixed(2))}
                        </span>
                      </div>
                    </Col>

                    {split?.paymentMethods?.reduce((acc, m) => acc + (m.amount || 0), 0) - split?.paidAmount > 0 && !split?.isNoChange && (
                      <>
                        <Col lg={3} xs={12} className="mt-3">
                          <div className="split-label2">Change:
                            <span style={{ fontWeight: "bold", marginLeft: "5px", color: "#36B94D" }}>
                              QR {(split?.paymentMethods?.reduce((acc, m) => acc + (m.amount || 0), 0) - split?.paidAmount)?.toFixed(2)}
                            </span>
                          </div>
                        </Col>
                      </>
                    )}
                    <Col lg={3} xs={12} className="mt-2" style={{ display: "flex", alignItems: "center" }}>
                      <FormGroup check className="mt-2 mb-2" style={{ display: isVIP || split?.changeAmount <= 0 ? "none" : "flex", justifyContent: "center" }}>
                        <Label check className="split-label2">
                          <Input type="checkbox" style={{ border: "0.5px solid black",marginTop:"0px"  }} checked={split?.isNoChange} onChange={e => {
                            const updated = [...splitCustomers];
                            const currentSplit = updated[index];
                            currentSplit.isNoChange = e.target.checked;
                            setState({ splitCustomers: updated });
                          }} />
                          No Change
                        </Label>
                      </FormGroup>
                    </Col>
                  </Row>
                </Row>
              </Row>
            );
          })}
        </>
      )}

      <Row>
        <Col lg={6} style={{ marginBottom: "0.8rem", display: isBillsplit ? "none" : "block" }}>
          <Label style={{ marginTop: "10px" }}>Select Payment Method</Label>
          <span style={{ fontSize: "10px", visibility: `${selectedPaymentMethods.some(pm => pm?.label === "Wallet") ? "unset" : "hidden"}`}} className="text-muted ms-2">
            {t("Balance")}:{"  "}
            <span style={{ color: "red", fontWeight: "600" }}>
              {customerDetails[0]?.wallet}
            </span>
          </span>
          <Select 
          options={paymentMethods.map(method => ({
            value: method._id,
            label: method.name,
            image_url: method.image_url,
            isDisabled: method.name === "Wallet" && !customerDetails[0]?.is_wallet_eligible
          }))} 
          placeholder={t("Select Payment Method")} 
          isMulti 
          onWheel={preventValueChangeOnScroll}
          isDisabled={customerDetails[0]?.customer_type === "VIP"} 
          value={selectedPaymentMethods} 
          onChange={handlePaymentMethodChange} 
          style={{ marginTop: "10px", boxShadow: "rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.06) 0px 2px 4px -1px" }} />
          {customerDetails[0] && !customerDetails[0].is_wallet_eligible && customerDetails[0]?.customer_type !== "VIP" && (
            <div className="toggle-wallet" style={{marginTop: "10px"}}>
              <button className='btn btn-sm btn-primary' type="button" onClick={() => handleEnableWalletForCustomer(customerDetails[0]._id)}>Enable Wallet</button>
            </div>
          )}
        </Col>
      </Row>

      <Row style={{ display: isBillsplit ? "none" : "flex" }}>
        {selectedPaymentMethods.map(selectedOption => (
          <Col lg={3} key={selectedOption.value}>
            <div style={{ display: "flex", alignItems: "center" }}>
              <img src={selectedOption.image_url} alt={selectedOption.label} style={{ marginRight: "4px", width: "21px", height: "21px" }} />
              <label>{`Paid by ${selectedOption.label}`}</label>
            </div>
            <AvField
              name={`paymentMethod_${selectedOption.value}`}
              type="number"
              value={formFieldValues[`paymentMethod_${selectedOption.value}`] || ''}
              validate={{ required: { value: true } }}
              placeholder="0"
              onChange={e => handlePaymentAmountChange(selectedOption, e.target.value)}
              onWheel={preventValueChangeOnScroll}
              style={{ marginTop: "10px", boxShadow: "rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.06) 0px 2px 4px -1px" }}
            />
          </Col>
        ))}
      </Row>

      <Row>
        <Col lg={6} style={{ paddingTop: "15px" }}>
          <AvField name="remarks" label={t("Remarks")} placeholder="Enter Remarks (Optional)" type="textarea" value={remarks} onChange={e => setState({ remarks: e.target.value })} validate={{ required: { value: false } }} />
        </Col>

        <Col lg={3} style={{ paddingTop: "15px", display: isBillsplit || isVipDiscountApplied ? "none" : "flex" }}>
          <AvField 
          id="changeAmount" 
          name="changeAmount" 
          label={t("Change Amount")} 
          type="number" 
          placeholder={remainingPaidAmount < 0 ? 0 : "N/A"} value={isNoChange ? 0 : finalChange} 
          onChange={handleChangeAmount} disabled 
          />
        </Col>

        <Col lg={3} style={{ paddingTop: "15px", display: (isVipDiscountApplied && !isBillsplit) || (isBillsplit && vipsDiscount > 0) ? "flex" : "none" }}>
          <AvField 
          id="vipDiscount"
          name="vipDiscount"
          label={t("VIP Discount")}
          type="number"
          value={isBillsplit ? vipsDiscount : (isVipDiscountApplied ? originalTotalPrice : 0)} 
          disabled 
          />
        </Col>

        <Col lg={3} style={{ paddingTop: "15px" }}>
          <AvField 
          id="paidAmount" 
          name="paidAmount" 
          label={t("Final Paid Amount")} 
          type="text" 
          placeholder={t("0")} 
          value={isBillsplit ? totalPaidByAllSplitCustomers.toFixed(2) : totalPaidAmount} readOnly disabled
           />
        </Col>

      </Row>
      <Row hidden={isBillsplit}>
        <Col style={{ width: "10px" }}>
          <FormGroup check className="mt-2 mb-2" style={{ display: customerDetails[0]?.customer_type === "VIP" ? "none" : "flex", justifyContent: "center" }}>
            <Label check>
              <Input 
              style={{ border: "0.5px solid black" }} 
              type="checkbox" 
              checked={is_personDisappear} 
              onChange={e => setState({ is_personDisappear: e.target.checked })} 
              />
              {t("mark as unpaid")}
            </Label>
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <hr />
        {is_personDisappear === false ? (
          <Button 
          style={{ width: "124px", margin: "auto", boxShadow: "rgba(255, 255, 255, .2) 0 3px 15px inset, rgba(0, 0, 0, .4) 0 3px 5px, rgba(0, 0, 0, .1) 0 10px 13px", transition: "transform 0.3s ease" }}
           onMouseEnter={e => { e.target.style.transform = "scale(1.05)" }} 
           onMouseLeave={e => { e.target.style.transform = "scale(1)" }} 
           type="submit" 
           disabled={isSubmitting}
           onSubmit={handleValidSubmit} 
           className="btn  btn-dark waves-effect">
            {isSubmitting ? <Spinner size={"sm"} /> :
            (<>
            <i className="bx bx-cart  font-size-18 align-middle me-2"></i>{" "}
             {("Check Out")}
              </>
            )}
          </Button>
        ) : (
          <Button style={{ width: "124px", margin: "auto", background: "#e00001", boxShadow: "rgba(255, 255, 255, .2) 0 3px 15px inset, rgba(0, 0, 0, .4) 0 3px 5px, rgba(0, 0, 0, .1) 0 10px 13px", transition: "transform 0.3s ease", border: "none" }} onMouseEnter={e => { e.target.style.transform = "scale(1.05)" }} onMouseLeave={e => { e.target.style.transform = "scale(1)" }} type="submit" onSubmit={handleValidSubmitUnpaid}>
            <i className="bx bx-cart  font-size-18 align-middle me-2"></i>{" "}
            {t("Unpaid")}
          </Button>
        )}
      </Row>

      <AddCustomerModal 
      isOpen={addCustomerModal}
      toggle={toggle}
      t={t}
      onSubmit={(e,v)=>handleAddCustomer(v)}
      />
    </AvForm>
  );
};

export default CheckoutForm;
